import React from 'react';

export default function SystemDocumentationPage() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="text-4xl font-bold text-gray-900 mb-4">
        System Documentation
      </h1>
      <p className="text-xl text-gray-600 max-w-3xl">
        This page will contain the system documentation.
      </p>
    </div>
  );
}
